import script from "./loading-content.vue?vue&type=script&setup=true&lang=ts"
export * from "./loading-content.vue?vue&type=script&setup=true&lang=ts"

import "./loading-content.vue?vue&type=style&index=0&id=37d5da8e&lang=scss"

const __exports__ = script;

export default __exports__